// ./controllers/flatpickr_controller.js
// import stimulus-flatpickr wrapper controller to extend it
import Flatpickr from 'stimulus-flatpickr'

// import translations
import { German } from 'flatpickr/dist/l10n/de.js'
import { Austria } from 'flatpickr/dist/l10n/at.js'
import { English } from 'flatpickr/dist/l10n/default.js'

// Erweitertes deutsches chrono für natürlichsprachige Datumseingabe
// („nächsten Freitag", „Monatsende", „KW 27", „in 3 Tagen" …)
import deChrono from '../src/datetime/de_chrono'

// import a theme (could be in your main CSS entry too...)
// import 'flatpickr/dist/themes/dark.css'

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {

    initialize() {
        // Get locale from data attribute or default to German
        const locale = this.element.dataset.locale || 'de'

        // Set locale based on country setting
        let selectedLocale
        switch(locale) {
            case 'at':
                selectedLocale = Austria
                break
            case 'en':
                selectedLocale = English
                break
            default:
                selectedLocale = German
        }

        // static:false bewusst: static:true verursacht in flatpickr 4.6.13 eine
        // Endlosschleife in buildMonthDays, wenn der Datepicker in einem zunächst
        // VERSTECKTEN Slideover/Modal initialisiert wird (z.B. todo[due] im „Neue
        // Aufgabe"-Panel) → Main-Thread blockiert (~4,5 Mio DOM-Nodes) → Windows-Edge
        // Renderer-OOM-Crash (msedge.exe 0xe0000008). Per CDP-Debugger nachgewiesen.
        // (Modal-Datepicker-Positionierung später separat lösen, z.B. lazy-init beim
        // Öffnen des Modals statt static.)

        // sets your language
        this.config = {
            locale: selectedLocale,
            time_24hr: true,
            allowInput: true,
            altInput: true,
            altFormat: 'd.m.Y',
            dateFormat: 'd.m.Y',
            altInputClass: "tw-form-control input",
            static: false,
            // Natural-Language-Datumsparser: flatpickr ruft parseDate bei JEDER String-Parse
            // (insbesondere beim Blur-Parse der manuellen Eingabe). Damit übernimmt chrono.de
            // Freitext („nächsten Freitag", „Monatsende", „in 3 Tagen", „KW 27", „übermorgen")
            // UND explizite Daten — die Eingabe wird also nicht mehr verworfen. „today" ist ein
            // flatpickr-Keyword (z.B. min-date:'today') und wird separat abgefangen.
            parseDate: (datestr) => {
                const s = (datestr || '').trim()
                if (!s) return undefined
                if (s.toLowerCase() === 'today') return new Date()
                const res = deChrono.parse(s, new Date(), { forwardDate: true })
                return (res.length && res[0].start) ? res[0].start.date() : undefined
            }
        }
    }

    // stimulus-flatpickr verdrahtet ready() als flatpickr-onReady (nach dem Aufbau).
    // Wir hängen einen dezenten Freitext-Hinweis unter das Feld, sichtbar beim Fokus.
    ready(selectedDates, dateStr, instance) {
        const field = instance.altInput || instance.input
        if (!field || field.dataset.nlHint) return
        field.dataset.nlHint = '1'
        const hint = document.createElement('div')
        hint.className = 'flatpickr-nl-hint text-xs text-gray-400 mt-1 hidden'
        hint.textContent = 'Auch Freitext: „morgen", „nächsten Freitag", „in 3 Tagen", „Monatsende", „KW 27"'
        field.insertAdjacentElement('afterend', hint)
        field.addEventListener('focus', () => hint.classList.remove('hidden'))
        field.addEventListener('blur', () => hint.classList.add('hidden'))

        // Leeren + Enter im Anzeigefeld (altInput) sauber committen. Ohne das:
        // - Leeren des Anzeigefelds schreibt NIE ins Original-Input zurueck ->
        //   Filter laesst sich nicht entfernen (alter Wert wird re-submittet).
        // - Enter submittet das Formular nativ BEVOR der Blur-Parse den neuen Wert
        //   committed -> alter Wert gewinnt ("stelle auf 23.7. um, es bleibt 25.7.").
        // clear()/setDate(..., true) feuern change auf dem Original-Input -> die
        // change->submit-Actions (search-filter/dynamic-filters) laufen mit dem
        // NEUEN Wert. setDate parst via parseDate, also inkl. Freitext (chrono).
        if (instance.altInput) {
            const alt = instance.altInput
            alt.addEventListener('blur', () => {
                if (alt.value.trim() === '' && instance.input.value !== '') instance.clear()
            })
            alt.addEventListener('keydown', (e) => {
                if (e.key !== 'Enter') return
                e.preventDefault()
                if (alt.value.trim() === '') { instance.clear() }
                else { instance.setDate(alt.value, true) }
            })
        }
    }
}
